import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./DialogHeader.styled";
export const DialogHeader = forwardRef(({ children, isCentered, ...otherProps }, ref) => (_jsx(Styled.DialogHeader, { ref: ref, isCentered: isCentered, "data-testid": "DialogHeader", ...otherProps, children: children })));
DialogHeader.displayName = "DialogHeader";
DialogHeader.defaultProps = {
    isCentered: false
};
